/**
 * Present when the menu checkbox item is checked.
 */
export const checked = 'data-checked';
/**
 * Present when the menu checkbox item is not checked.
 */
export const unchecked = 'data-unchecked';
/**
 * Present when the menu checkbox item is disabled.
 */
export const disabled = 'data-disabled';
/**
 * Present when the menu checkbox item is highlighted.
 */
export const highlighted = 'data-highlighted';
